const state = {
  stack: [],
  error: null
};

const mutations = {
  error: (state, error) => {
    state.error = error;
    if (error) {
      state.stack.push(error);
    }
  }
};

export default { state, mutations };
